<template>
  <div class="home-three">
    <layouts-header></layouts-header>
    <!-- Banner -->
    <indexfour-banner></indexfour-banner>
    <!-- /Banner -->

    <!-- Category  Section -->
    <category-four></category-four>
    <!-- /Category  Section -->

    <!-- Feature Section -->
    <feature-four></feature-four>
    <!-- /Feature Section -->

    <!-- Car Section -->
    <car-four></car-four>
    <!-- /Car Section -->

    <!-- Brand Section -->
    <brand-four></brand-four>
    <!-- /Brand Section -->

    <!-- Rental Section -->
    <rental-four></rental-four>
    <!-- /Rental Section -->

    <!-- Popular Section -->
    <popular-four></popular-four>
    <!-- /Popular Section -->

    <!-- Testimonial Section -->
    <testimonial-four></testimonial-four>
    <!-- /Testimonial Section -->

    <price-four></price-four>
  </div>
</template>
